import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=0b91bc3b&"
import script from "./duration.vue?vue&type=script&lang=js&"
export * from "./duration.vue?vue&type=script&lang=js&"
import style0 from "./duration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "duration.vue"
export default component.exports